import React from 'react';
import { IconButton, Menu, MenuItem, Tooltip } from '@mui/material';
import LanguageIcon from '@mui/icons-material/Language';
import { useRTL } from '../../context/RTLContext';

const languages = [
  { code: 'en', name: 'English', nativeName: 'English', dir: 'ltr' },
  { code: 'ar', name: 'Arabic', nativeName: 'العربية', dir: 'rtl' },
  { code: 'he', name: 'Hebrew', nativeName: 'עברית', dir: 'rtl' },
  { code: 'fr', name: 'French', nativeName: 'Français', dir: 'ltr' },
  { code: 'es', name: 'Spanish', nativeName: 'Español', dir: 'ltr' },
  { code: 'de', name: 'German', nativeName: 'Deutsch', dir: 'ltr' },
  { code: 'hi', name: 'Hindi', nativeName: 'हिन्दी', dir: 'ltr' },
  { code: 'zh', name: 'Chinese', nativeName: '中文', dir: 'ltr' },
];

const LanguageSwitcher: React.FC = () => {
  const { language, setLanguage, direction } = useRTL();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLanguageSelect = (langCode: string) => {
    setLanguage(langCode);
    handleClose();
  };

  const currentLanguage = languages.find(lang => lang.code === language.split('-')[0]);

  return (
    <>
      <Tooltip title={`Language: ${currentLanguage?.nativeName || 'English'}`}>
        <IconButton
          onClick={handleClick}
          sx={{
            position: 'fixed',
            top: 16,
            [direction === 'rtl' ? 'left' : 'right']: 16,
            zIndex: 1300,
            bgcolor: 'background.paper',
            boxShadow: 1,
            '&:hover': {
              bgcolor: 'background.paper',
              boxShadow: 2,
            }
          }}
        >
          <LanguageIcon />
        </IconButton>
      </Tooltip>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: direction === 'rtl' ? 'left' : 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: direction === 'rtl' ? 'left' : 'right',
        }}
      >
        {languages.map((lang) => (
          <MenuItem
            key={lang.code}
            onClick={() => handleLanguageSelect(lang.code)}
            selected={language.split('-')[0] === lang.code}
          >
            <span style={{ marginInlineEnd: '8px' }}>{lang.nativeName}</span>
            <span style={{ fontSize: '0.875rem', opacity: 0.7 }}>
              ({lang.name})
            </span>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default LanguageSwitcher;